import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import AuthForm from "../components/Auth/AuthForm";
import history from "../history";

function Login() {
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth.is_confirmed) {
      history.replace("/");
    }
  }, [auth.is_confirmed]);

  return (
    <React.Fragment>
      <Container>
        <Row
          style={{ height: "calc(100vh - 1.5rem)" }}
          className="justify-content-center align-items-center"
        >
          <Col md={6} lg={4}>
            <AuthForm />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default Login;
